<script setup lang="ts">
    import { useAuthStore, useSpaceStore } from "~/stores"
    import { useRouter } from "vue-router"
    import { computed } from "vue"

    const router = useRouter()

    const authStore = useAuthStore()
    const spaceStore = useSpaceStore()

    function goToHomePage() {
        router.push({ name: "space.home" })
    }

    function goToBack() {
        router.back()
    }

    const onHomePage = computed(() => {
        return router.currentRoute.value.name === "space.home"
    })

    const onProjectPage = computed(() => {
        return router.currentRoute.value.name === "space.project"
    })

    const onCommandePage = computed(() => {
        return router.currentRoute.value.name === "space.commande"
    })

    const currentProject = computed(() => {
        const id_projet = router.currentRoute.value.params.id_projet

        // const id_devis = router.currentRoute.value.params.id_devis

        return spaceStore.getProject.find(
            (project) => project.IDPROJET === parseInt(id_projet),
        )
    })

    const currentDevis = computed(() => {
        const id_devis = router.currentRoute.value.params.id_devis
        return spaceStore.getAllDevis.find(
            (devis) => devis.IDDEVIS === parseInt(id_devis),
        )
    })

    defineProps({
        title: {
            type: String,
            default: "Espace Client",
        },
        subtitle: {
            type: String,
            default: "Bienvenue dans votre espace client",
        },
    })
</script>

<template>
    <div class="header">
        <v-system-bar window class="reduced-height" dark color="transparent">
            <div v-if="!onHomePage">
                <v-btn icon="mdi-home" variant="text" @click="goToHomePage" />
                <v-btn icon="mdi-arrow-left" variant="text" @click="goToBack" />
            </div>
            <v-spacer />
            <v-btn variant="text" @click="authStore.logout()">
                Deconnexion
            </v-btn>
        </v-system-bar>
        <div class="content-header">
            <div v-if="onHomePage">
                <h1>
                    Bonjour
                    {{ authStore.getUser?.PRENOM || authStore.getUser?.NOM }}
                </h1>
                <p>Heureux de vous voir dans votre espace client</p>
            </div>

            <div
                v-if="onProjectPage"
                class="d-flex"
                style="justify-content: space-between"
            >
                <div>
                    <h2>Projet : {{ currentProject?.DESCRIPTION }}</h2>
                    <h5>
                        {{ currentProject?.ADRESSE_CHANTIER.ADRESSE_COMPLETE }}
                    </h5>
                    <h5>
                        {{ currentProject?.ADRESSE_CHANTIER.CODE_POSTAL }}
                        {{ currentProject?.ADRESSE_CHANTIER.VILLE }}
                    </h5>
                </div>
                <v-chip
                    :color="currentProject?.etatProjet?.color"
                    variant="flat"
                    class="wrap-text"
                    >{{ currentProject?.etatProjet.title }}</v-chip
                >
            </div>

            <div v-if="onCommandePage">
                <h2>Suivi de commande</h2>
                <h4>{{ currentDevis?.NUMERO_DEVIS }}</h4>
            </div>
        </div>
        <SpaceUserInformation :current-project="currentProject" />
    </div>
</template>

<style scoped>
    .content-header {
    padding: 50px 20px;
    align-items: center;
    background: linear-gradient(135deg, #0b3a73, #2ca84f);
    color: white;
}

.wrap-text {
    white-space: normal !important;
    line-height: 1;
}


.reduced-height {
    height: 30px !important;
    display: flex;
    justify-content: flex-end;
}

.reduced-height .v-btn {
    text-transform: none;
}

.reduced-height .v-btn__content:hover {
    opacity: 0.8 !important;
}

.v-btn:disabled {
    color: rgba(255, 255, 255, 1) !important;
}
</style>
